import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ClearDataIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
			{...props?.innerSvgProps}
		>
			<path
				d='M3.4375 11.1953V4.0625C3.4375 3.89674 3.50335 3.73777 3.62056 3.62056C3.73777 3.50335 3.89674 3.4375 4.0625 3.4375H15.9375C16.1033 3.4375 16.2622 3.50335 16.3794 3.62056C16.4967 3.73777 16.5625 3.89674 16.5625 4.0625V15.9375C16.5625 16.1033 16.4967 16.2622 16.3794 16.3794C16.2622 16.4967 16.1033 16.5625 15.9375 16.5625H10.5938'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.2'
			/>
			<path
				d='M10 11.875L5 16.875L2.5 14.375'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.2'
			/>
		</svg>
	);
};

export default ClearDataIcon;
